import { fetchers } from '@pes-ui/utils';
import { scConfigurationToPostData } from '@pes-ui/components/dist/collection/components/UI/product-selector/product-selector-utils';
import { productsParamsToPostData } from "@pes-ui/components/dist/collection/globals/my-products/utils";

export function getMyProductsAPI({ countryCode, languageCode }) {
  return {
    removeProduct(id) {
      return fetchers.deleteMyProducts({ countryCode, languageCode, params: { id } });
    },

    addProducts(productData) {
      const {
        productId: id,
        productQty: quantity,
        creationDate,
        replacingQty,
        parentId,
        groupId,
        groupType,
        displayName,
      } = productData;

      return fetchers.postMyProducts({
        countryCode,
        languageCode,
        payload: productsParamsToPostData({
          id,
          quantity,
          creationDate,
          replacingQty,
          groupId,
          groupType,
          displayName,
          parentId,
        }),
      });
    },

    changeGroupName(id, name) {
        return fetchers.postMyProducts({
            countryCode,
            languageCode,
            payload: {
                repositoryId: id,
                configurationName: name
            }
        });
    },

    getProductFullData(id) {
      return fetchers.getMyProducts({
        countryCode,
        languageCode,
        id,
        params: {
          format: 'full',
        },
      });
    },

    getProductsFullData() {
      return fetchers.getMyProducts({
        countryCode,
        languageCode,
        params: { format: 'full' },
      });
    },

    addSCProducts(productData) {
      return fetchers.postMyProducts({
        countryCode,
        languageCode,
        payload: scConfigurationToPostData(productData),
      });
    },
  };
}
